import React, { useEffect, useState, useRef } from 'react';
import { Dialog, Typography, LinearProgress, Stack } from '@mui/material';
import { useModals } from '@mattjennings/react-modal-stack';
import Iconify from '@/components//Iconify';

const TIME_TO_WAIT = 8;

const ThreeDSecureRedirectionDialog = ({
  open,
  onTimerFinish = () => {},
  onAbort = () => {},
  onInit = () => {},
}) => {
  const { closeModal } = useModals();
  const [timer, setTimer] = useState(0);
  const [allowEvents, setAllowEvents] = useState(false);
  const [onTime, setOnTime] = useState(false);
  const [proceed, setProceed] = useState(false);

  const timerRef = useRef(null);

  const progressPct = (timer * 100) / TIME_TO_WAIT;

  const handleEvent = (event) => {
    if (!allowEvents) return;
    onAbort();
    closeModal();
  };

  // once open modal start interval to initiate countdown timer
  useEffect(() => {
    timerRef.current = setInterval(() => {
      setTimer((prev) => prev + 1);
    }, 1000);
    setAllowEvents(true);
    return () => clearInterval(timerRef.current);
  }, [open]);

  // handle init effect to wait for save info function
  // this is to prevent go to 3Ds challenge page without saving booking info
  // by default proceed is false due to the async nature of the onInit function
  // this is by sometimes 8s isn´t enough time to save the booking info
  useEffect(() => {
    const handleInit = async () => {
      const response = await onInit();
      if (response === 'ok') {
        setProceed(true);
      } else {
        setProceed(false);
      }
    };
    handleInit();
  }, []);

  useEffect(() => {
    if (timer > TIME_TO_WAIT - 2) {
      setAllowEvents(false);
      setOnTime(true);
    }
  }, [timer, open]);

  // efecto para poner el evento de recarga de la pagina cuando se esta por ir al challenge
  // o cuando se hace click en el botón de regresar
  useEffect(() => {
    if (open) {
      window.addEventListener('beforeunload', handleEvent);
      window.addEventListener('popstate', handleEvent);

      return () => {
        window.removeEventListener('beforeunload', handleEvent);
        window.removeEventListener('popstate', handleEvent);
      };
    }
  }, [allowEvents, open]);

  useEffect(() => {
    if (!onTime) return;

    if (proceed) {
      onTimerFinish();
    } else {
      onAbort(true);
    }
  }, [onTime, proceed]);

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onClose={() => {}} maxWidth="sm">
      <Stack
        spacing={3}
        sx={{
          padding: '40px 32px',
        }}
      >
        <Stack justifyContent="center" alignItems="center">
          <Iconify
            icon="ph:shield-check-duotone"
            fontSize="56px"
            color="primary.main"
          />
        </Stack>
        <Stack
          spacing={1}
          sx={{
            width: '100%',
          }}
        >
          <Typography
            paragraph
            sx={{
              margin: 0,
              padding: 0,
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[900]
                  : theme.palette.grey[100],
              fontSize: '20px',
              fontWeight: 600,
              textAlign: 'center',
            }}
            variant="h5"
          >
            Validando tu identidad con tu banco
          </Typography>
          <Typography
            paragraph
            sx={{
              margin: 0,
              padding: 0,
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[700]
                  : theme.palette.grey[300],
              textAlign: 'center',
            }}
            variant="body1"
          >
            Estamos realizando el proceso de validación con tu banco para
            autorizar tu pago. Al finalizar, tu compra seguirá procesándose
            automáticamente.
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[400]
                  : theme.palette.grey[700],
              textAlign: 'center',
            }}
          >
            No cierres ni actualices esta ventana hasta completar la
            verificación.
          </Typography>
        </Stack>

        <LinearProgress
          color="primary"
          variant="determinate"
          value={progressPct}
        />
      </Stack>
    </Dialog>
  );
};

export default ThreeDSecureRedirectionDialog;
